import React from 'react';
import config from '../../config'

const BannerPublicitario = ({ banners, onBannerClick }) => {
  // Verificar si hay banners y tomar el primero
  const banner = banners?.[0];

  // No mostrar nada si no hay banners
  if (!banner) {
    return null;
  }
  
  return (
    <div
      className="relative w-full cursor-pointer mx-0 px-0 mb-16 overflow-hidden"
      onClick={() => onBannerClick(banner)}
      style={{ cursor: banner.haveRoute ? "pointer" : "default" }}
    >
      <img
        style={{ width: '100%', height: 'auto', maxHeight: '60vh', display: 'block', objectFit: 'cover' }}
        src={
          banner.image.url.trim().startsWith("http")
            ? banner.image.url.trim()
            : config.serverUri + banner.image.url.trim()
        }
        alt={banner.title || 'Banner'}
        loading="lazy"
      />
    </div>
  );
};

export default BannerPublicitario;
